import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsModalComponent } from './terms-modal/terms-modal.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AutorizationModalComponent } from './autorization-modal/autorization-modal.component';

@NgModule({
  declarations: [
    TermsModalComponent,
    AutorizationModalComponent
  ],
  imports: [CommonModule, NgbModule],
  exports: [TermsModalComponent, AutorizationModalComponent],
})
export class CommonComponentsModule {}
